import { put } from "@redux-saga/core/effects";
import axios from "axios";

import { ChangePageOrderRequestActionType } from "../types";
import { IErrorType } from "../../types/errors.d";
import { PagesService } from "../../../services/pages";
import { changePageOrderSuccess, changePageOrderFailure } from "../actionCreators";
import { undo } from "../../../helpers/undoable";

export function* changePageOrderSaga(action: ChangePageOrderRequestActionType) {
    const {
        payload: { pageId, dropIndex },
    } = action;
    try {
        yield PagesService.changePageOrder({ pageId, dropIndex });
        yield put(changePageOrderSuccess({}));
    } catch (error) {
        yield put(undo(action));
        if (axios.isAxiosError(error))
            yield put(changePageOrderFailure({ errorType: IErrorType.AXIOS, data: error.response?.data }));
        else yield put(changePageOrderFailure({ errorType: IErrorType.NATIVE, data: error }));
    }
}
